module.exports = __webpack_public_path__ + "static/2019-58844c3cdb3dd797ec4cf7386ff097c3.png";